export const CANCELLATION_WINDOW_HOURS = 24;
export const LATE_CANCEL_FEE_PERCENT = 50;
export const SHOP_PHONE = "(252) 315-3416";

export const POLICIES = [
  {
    id: "cancellation",
    title: "Cancellation & Rescheduling",
    points: [
      `You may cancel or reschedule free of charge up to ${CANCELLATION_WINDOW_HOURS} hours before your appointment.`,
      `Cancellations or reschedules made within ${CANCELLATION_WINDOW_HOURS} hours of your appointment are considered late and are subject to a fee of ${LATE_CANCEL_FEE_PERCENT}% of the service price.`,
      `Within ${CANCELLATION_WINDOW_HOURS} hours, changes can no longer be made online — please call the shop at ${SHOP_PHONE} and we'll do our best to help.`,
    ],
  },
  {
    id: "no-show",
    title: "No-Show Policy",
    points: [
      "A “no-show” is any missed appointment where the client does not arrive and does not call ahead.",
      "Clients who no-show may be required to pay a deposit or prepay in full to book future appointments.",
      "Repeated no-shows may result in the loss of online booking privileges.",
    ],
  },
  {
    id: "late-arrival",
    title: "Late Arrivals",
    points: [
      "Please arrive a few minutes early. Arriving more than 10–15 minutes late may require rescheduling out of respect for the next client.",
      "Every effort will be made to accommodate you, but a shortened service or reschedule may be necessary.",
    ],
  },
];

export const POLICY_SUMMARY = `Free cancellation up to ${CANCELLATION_WINDOW_HOURS}h before. Late cancellations/no-shows are subject to a ${LATE_CANCEL_FEE_PERCENT}% fee or deposit for future bookings.`;
